import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { useMail } from "./use-mail";

export function MailSearch() {
  const { searchQuery, setSearchQuery } = useMail();

  return (
    <div className="relative p-2 border-b">
      <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder="Search emails..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="pl-8"
      />
    </div>
  );
}
